export function getConnectedUser() {
  const strUser = localStorage.getItem("user");
  return JSON.parse(strUser);
}

export function setConnectedUser(user) {
  localStorage.setItem("user", JSON.stringify(user));
}

